'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _adverseEventSearch = require('./adverse-event-search.component');

var _adverseEventSearch2 = _interopRequireDefault(_adverseEventSearch);

require('./adverse-event-search.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.adverseEvents.adverseEventSearch', []).component('adverseEventSearch', _adverseEventSearch2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/adverse-events/adverse-event-search/adverse-event-search.module.js